import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { getGuid } from 'owa-guid';
import isEntrySourceUndo from '../utils/isEntrySourceUndo';
import type { MetricsInfo, QuickComposeViewState } from 'owa-calendar-compose-types';
import {
    CharmSelectionType,
    QuickComposePivotType,
} from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { mutator, ActionMessage } from 'satcheljs';
import { getDefaultShouldShortenEventDuration } from 'owa-calendar-cloud-settings';

import { default as showQuickCompose } from '../actions/initActions/showQuickCompose';
// Shows the callout for quick compose

mutator(showQuickCompose, (actionMessage: ActionMessage) => {
    let entrySource = actionMessage.entrySource;
    let anchor = actionMessage.anchor;
    let viewType = actionMessage.viewType;

    const isUndo = isEntrySourceUndo(entrySource);
    let store = getComposeStore();
    store.metricsInfo = {
        quickComposeEntrySource: entrySource,
        quickComposeControlUsageMetrics: {
            usageDict: {},
            startTimeDict: {},
            durationDict: {},
        },
        formSessionId: getGuid(),
    } as MetricsInfo;

    if (isUndo) {
        // The store already exists
        // If an anchor is passed through update the store value
        if (anchor) {
            (store.uiState as QuickComposeViewState).surfaceAnchor = anchor;
        }
    } else {
        store.uiState = {
            surfaceAnchor: anchor,
            charmSelection: CharmSelectionType.None,
            isUndoNotificationShown: store.uiState?.isUndoNotificationShown,
            isOptionalAttendeeWellEnabled: false,
            shouldFocusOptionalAttendeeWellOnMount: false,
            showCompactRecipientWell: false,
            unresolvedLocation: null,
            activePivot: QuickComposePivotType.Event,
            showExpandedEditor: false,
            bodyViewState: {
                content: null,
                isDirty: false,
            },
            cachedEventData: {},
            oofViewState: {
                declineNewInvitationsEnabled: undefined,
                declineExistingCalendarEventsEnabled: undefined,
                autoReplyEnabled: false,
                autoReplyViewState: null,
                mailboxAutoReplyConfigurationLoadingStatus: null,
                mailboxAutoReplyConfiguration: null,
                startDate: null,
                endDate: null,
                hideOverridingWarningMessage: false,
                optionsPageLoadingState: null,
            },
            viewType: viewType,
            isOnlineMeetingExplicitlySet: false,
            shouldAdjustStartTimeEndTime: getDefaultShouldShortenEventDuration(),
        } as QuickComposeViewState;
    }
});
